module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "u-relative u-flex u-flex-ai--center u-fit"
  }, [_c('div', {
    staticClass: "c-home-slide--3__container u-marg-x-auto u-flex u-flex-ai--center u-flex-jc--start@sm u-w10of12"
  }, [_c('div', {
    staticClass: "c-home-slide--3__container__left-side u-fit-w u-force-3d"
  }, [_c('div', {
    staticClass: "c-home-slide--3__container__left-side__wrapper u-inline-block u-fit"
  }, [_c('app-home-slide-nb-title', {
    staticClass: "c-home-slide__element has-delay-0",
    attrs: {
      "index": 3,
      "number": "03",
      "label": "Reward Calculation",
      "color": "white"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "c-home-slide__element has-delay-0 u-hide u-overflow-h u-opacity--0",
    staticStyle: {
      "width": "1px",
      "height": "1px"
    }
  }, [_vm._v("We calculate rewards from")]), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('div', {
    staticClass: "c-home-slide--3__slides c-home-slide__element has-delay-2 u-relative u-force-3d u-fit-w",
    class: ['is-coming-from-' + _vm.comeFromPosition, 'is-level-' + _vm.activeLevel]
  }, _vm._l((_vm.slides), function(slide, index) {
    return _c('div', {
      staticClass: "c-home-slide--3__slides__slide js-home-slide--3-slide o-content u-absolute u-pos-tr u-flex u-flex-ai--start u-fit-w u-color--white",
      class: [_vm.activeLevel === (index + 1) ? 'is-active' : '', _vm.activeLevel > (index + 1) ? 'is-left' : '', _vm.activeLevel < (index + 1) ? 'is-right' : '', 'c-home-slide--3__slides__slide--' + (index + 1)]
    }, [_c('div', {
      staticClass: "u-flex u-flex-ai--center u-w2of5"
    }, [_c('div', {
      staticClass: "c-home-slide--3__slides__slide-title u-relative"
    }, [_c('strong', [_vm._v(_vm._s(slide.title))])]), _vm._v(" "), _c('div', {
      staticClass: "c-home-slide--3__slides__slide-line u-relative u-marg-x-auto u-w1of3 u-bg--white u-opacity--90"
    })]), _vm._v(" "), _c('ul', {
      staticClass: "c-home-slide--3__slides__slide-list o-list--none u-w3of5"
    }, _vm._l((slide.content), function(content, i) {
      return _c('li', [_c('span', {
        staticClass: "c-home-slide--3__slides__slide-list--1 u-relative u-inline-block u-valign-middle"
      }, [_vm._v(_vm._s(content.title))]), _vm._v(" "), _c('span', {
        staticClass: "c-home-slide--3__slides__slide-list--2 u-relative u-marg-l-xs u-inline-block u-valign-middle u-opacity--50"
      }, [_vm._v(_vm._s(content.description))])])
    }))])
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "c-home-slide--3__title c-home-slide__element has-delay-1 u-color--white t-fweight--light u-lheight--125p"
  }, [_c('div', {
    staticClass: "c-home-slide--3__title--1 u-relative"
  }, [_vm._v("We calculate")]), _vm._v(" "), _c('div', {
    staticClass: "c-home-slide--3__title--2 u-relative"
  }, [_c('span', {
    staticClass: "u-color--brand-primary"
  }, [_vm._v("rewards")]), _vm._v(" from")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-125950fa"}!./src/scripts/components/app-home-slide-3/template.html
// module id = 453
// module chunks = 0